import { render, staticRenderFns } from "./bloodglucosequality.vue?vue&type=template&id=84b03afc&scoped=true&"
import script from "./bloodglucosequality.vue?vue&type=script&lang=js&"
export * from "./bloodglucosequality.vue?vue&type=script&lang=js&"
import style0 from "./bloodglucosequality.vue?vue&type=style&index=0&id=84b03afc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b03afc",
  null
  
)

export default component.exports